import React, { useEffect, useState } from "react";
import { Row, Col, Button, Card, Divider, Space, Alert, Select } from "antd";

import { EditOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPhoneSquare,
  faBuildingShield,
  faLocationDot,
  faCalendarAlt,
  faHandPointer,
  faUserAlt,
  faListNumeric,
  faHashtag,
  faCogs,
} from "@fortawesome/free-solid-svg-icons";
import { GetLeadByIdApi } from "../LeadsAPI";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import {
  getClientAPI,
  getEmployeeAPI,
  GetLookupListApi,
  getStatusAPI,
} from "CommonComponents/Lookup/LookupAPI";
import { FormattedMessage } from "react-intl";
import AddLead from "./AddLead";
import LookupTypeEnum from "features/Enums/LookupTypeEnum";
function LeadView() {
  const { companyId, leadId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lead = useSelector((state) => state.leads.leadRecordById);
  const clients = useSelector((state) => state.lookup.clientList);
  const employeeList = useSelector((state) => state.lookup.employesList);
  const addressProvinces = useSelector(
    (state) => state.lookup.addressProvinces
  );
  const addressCountries = useSelector(
    (state) => state.lookup.addressCountries
  );
  const companyServices = useSelector(
    (state) => state.lookup.lookupData[LookupTypeEnum.CompanyService.id]
  );
  const [selectedLead, setSelectedLead] = useState(null);
  const [open, setOpen] = useState(false);

  const handleEdit = (id) => {
    navigate(`/editLead/${id}`);
  };
  const leadCloseDuration = lead?.createdDate
    ? dayjs().diff(dayjs(lead.createdDate), "day")
    : "0";

  const showDrawer = () => {
    setOpen(true);
    setSelectedLead(lead);
  };
  const onClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (leadId) {
      dispatch(GetLeadByIdApi(leadId));
    }
  }, [dispatch]);
  const input = {
    pageNo: null,
    pageSize: 10,
    searchQuery: "",
  };
  const deliveryAddress = lead?.deliveryAddress;
  const billingAddress = lead?.billingAddress;

  useEffect(() => {
    dispatch(getStatusAPI());
    dispatch(getClientAPI());
    dispatch(getEmployeeAPI());
    dispatch(GetLookupListApi(LookupTypeEnum?.CompanyService?.id, input));
  }, [dispatch]);
  const addressMaps = (address) => {
    if (!address) return { text: "N/A", mapUrl: null };
    const text = [
      address.address1,
      address.address2,
      address.city,
      address.provinceName,
      address.countryName,
      address.zip,
    ]
      .filter(Boolean)
      .join(", ");
    const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      text
    )}`;
    return { text, mapUrl };
  };

  return (
    <>
      <Card
        title={<FormattedMessage id="Lead.Requirement" />}
        size="small"
        extra={
          <Button
            size="small"
            onClick={() => {
              navigate(`/${companyId}/editlead`, {
                state: { lead: lead },
              });
            }}
          >
            <EditOutlined />
          </Button>
        }
      >
        <Row gutter={32} className="new-comp-info">
          <Col xs={24}>
            {/* {lead?.leadType == 1 ? (
              <>
                <p className="mt-10">
                  <FontAwesomeIcon icon={faUserAlt} />
                  &nbsp;{<FormattedMessage id="Lead.CustomerName" />}
                </p>
                <span className="mt-10">
                  {lead?.clientId
                    ? `${clients.find((c) => c.id === lead.clientId)?.nameEn}`
                    : "N/A"}
                </span>
              </>
            ) : (
              <>
                <p>
                  <FontAwesomeIcon icon={faBuildingShield} />
                  &nbsp; {<FormattedMessage id="Lead.CompanyName" />}
                </p>
                <span>
                  {lead?.clientId
                    ? `${clients.find((c) => c.id === lead.clientId)?.nameEn}`
                    : "N/A"}
                </span>
              </>
            )} */}
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <p style={{ margin: 0, color: "#334155" }}>{lead?.requirement}</p>
            </div>
            {/* <p className="mt-10">
              <FontAwesomeIcon icon={faCogs} />
              &nbsp; {<FormattedMessage id="Quote.Services" />}
            </p>
            <span>
              {
                companyServices?.find(
                  (service) => service.id === lead?.companyServiceId
                )?.nameEn
              }
            </span> */}
            {/* <p className="mt-10">
              <FontAwesomeIcon icon={faUserAlt} />
              &nbsp; {<FormattedMessage id="Leads.SalesPerson" />}
            </p>

            <span>
              {lead?.responsibleId
                ? `${
                    employeeList.find(
                      (employee) => employee.id === lead.responsibleId
                    )?.firstName || ""
                  } ${
                    employeeList.find(
                      (employee) => employee.id === lead.responsibleId
                    )?.lastName || ""
                  }`
                : "N/A"}
            </span> */}

            {/* <p className="mt-10">
              <FontAwesomeIcon icon={faPhoneSquare} />
              &nbsp;
              <FormattedMessage id="Lead.PhoneNumber" />
            </p>
            <span>
              {lead?.countryCode}
              {lead?.mobileNumber}
            </span> */}
            {/* <p className="mt-10">
              <FontAwesomeIcon icon={faEnvelope} />
              &nbsp;
              {<FormattedMessage id="Lead.Email" />}
            </p>
            <span>{lead?.email}</span> */}
            {/* <p className="mt-10">
              <FontAwesomeIcon icon={faLocationDot} />
              &nbsp;
              {<FormattedMessage id="Lead.Address" />}
            </p>
            {/* {(() => {
              const address = lead
                ? [
                    lead?.addressLine1,
                    lead?.addressLine2,
                    lead?.city,
                    addressProvinces.find((p) => p.id === lead?.provinceId)
                      ?.provinceNameEn,
                    addressCountries.find((c) => c.id === lead?.countryId)
                      ?.countryNameEn,
                    lead?.zip,
                  ]
                    .filter(Boolean)
                    .join(", ")
                : "";

              return address ? (
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    address
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {address}
                </a>
              ) : (
                <span>N/A</span>
              );
            })()} */}
            {/* <p>
              <strong>
                <FormattedMessage id="AddEstimate.ShippingAddress" />:
              </strong>
              <br />
              {deliveryAddress ? (
                <a
                  href={addressMaps(deliveryAddress).mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {addressMaps(deliveryAddress).text}
                </a>
              ) : (
                "N/A"
              )}
            </p>
            <p>
              <strong>
                <FormattedMessage id="AddEstimate.BillingAddress" />:
              </strong>
              <br />
              {billingAddress ? (
                <a
                  href={addressMaps(billingAddress).mapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {addressMaps(billingAddress).text}
                </a>
              ) : (
                "N/A"
              )}
            </p> */}
          </Col>
          <Divider />
          <Col xs={24} className="mt-2">
            <Space style={{ display: "flex", justifyContent: "space-between" }}>
              <p>{<FormattedMessage id="Lead.Date" />}</p>
              <p>{dayjs(lead?.dateTime).format("DD-MMM-YYYY")}</p>
            </Space>
            <Space
              style={{ display: "flex", justifyContent: "space-between" }}
              className="mt-1"
            >
              <p>{<FormattedMessage id="Lead.LeadAge" />}</p>
              <div
                style={{
                  backgroundColor: "#3a5892",
                  color: "#fff",
                  borderRadius: "50%",
                  width: 24,
                  height: 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                }}
              >
                {leadCloseDuration !== null ? leadCloseDuration : "N/A"}
              </div>
            </Space>
            <Space
              style={{ display: "flex", justifyContent: "space-between" }}
              className="mt-1"
            >
              <p>{<FormattedMessage id="Lead.LastModified" />}</p>
              <p>
                {lead?.updatedDate
                  ? dayjs(lead.updatedDate).format("DD MMMM YYYY")
                  : "N/A"}
              </p>
            </Space>
            <Space
              style={{ display: "flex", justifyContent: "space-between" }}
              className="mt-1"
            >
              <p>{<FormattedMessage id="Lead.ModifiedBy" />}</p>
              <p>
                {employeeList.find((c) => c.id === lead?.updatedBy)
                  ?.firstName || "N/A"}
              </p>
            </Space>
          </Col>
          <Col>
            {lead?.statusId == 7 && lead?.rejectedReason && (
              <>
                <p className="mt-10">
                  <FormattedMessage id="Lead.RejectionReason" />
                </p>
                <span>{lead.rejectedReason}</span>
              </>
            )}
          </Col>
        </Row>
      </Card>
      {/* {open && ( */}
      {/* <AddLead
        leadId={leadId}
        open={open}
        setOpen={setOpen}
        selectedLead={selectedLead}
        setSelectedLead={setSelectedLead}
        onClose={onClose}
      /> */}
      {/* )} */}
    </>
  );
}

export default LeadView;
